/** Most keywords the select-all checkbox adds to the keyword list. */
export const SELECT_ALL_MAX = 50;

/** Display state of the select-all header checkbox. */
export type SelectAllState = 'checked' | 'partial' | 'empty';

/**
 * Derives the select-all checkbox state: empty when nothing is selected, checked when
 * every keyword in the filtered view is selected or `max` is reached, partial otherwise.
 */
export function getSelectAllState(
    visibleWords: string[],
    selectedWords: string[],
    max: number = SELECT_ALL_MAX,
): SelectAllState {
    if (selectedWords.length === 0) return 'empty';
    if (selectedWords.length >= max) return 'checked';

    const selected = new Set(selectedWords);
    const isEveryVisibleSelected = visibleWords.length > 0 && visibleWords.every(word => selected.has(word));
    return isEveryVisibleSelected ? 'checked' : 'partial';
}

/** Appends visible words, in order, to the selection until it holds `max` words. */
export function selectUpToMax(
    visibleWords: string[],
    selectedWords: string[],
    max: number = SELECT_ALL_MAX,
): string[] {
    if (selectedWords.length >= max) return selectedWords;

    const result = [...selectedWords];
    const selected = new Set(selectedWords);
    for (const word of visibleWords) {
        if (result.length >= max) break;
        if (!selected.has(word)) {
            selected.add(word);
            result.push(word);
        }
    }
    return result.length === selectedWords.length ? selectedWords : result;
}
